import stringify from "fast-json-stable-stringify";
import type { ICache } from "@ihr-radioedit/inferno-core";
import * as Webapi from "@ihr-radioedit/inferno-webapi";
import { Cursor } from "@ihr-radioedit/inferno-core";
import { ILog } from "@ihr-radioedit/inferno-core";
import { getSdk, sdkOpts } from "@ihr-radioedit/inferno-core";
// import { ObservableMap } from "mobx";

const sdk = getSdk(sdkOpts());
const log = ILog.logger("Calendar");

export const DEFAULT_LIMIT = 10;

export const getEventCategories = (query: Webapi.GetEventCategoriesQueryVariables) =>
    sdk!.GetEventCategories.queryAsPromise(query).then(r => r.data?.sites.find?.eventCategories || []);

export const getEvents = (cache: Map<string, ICache>) => (variables: Webapi.GetEventsQueryVariables) =>
    new Cursor<Webapi.CalendarEventFragment[], Webapi.GetEventsQueryVariables, Webapi.CalendarEventFragment>(
        variables,
        async opts => {
            const paginationVars = { ...opts, limit: (opts.limit || DEFAULT_LIMIT) + 1 };
            try {
                const response = await sdk!.GetEvents.queryAsPromise(paginationVars);
                return response.data?.sites?.find?.events || [];
            } catch (e) {
                log.debug("Error in loader", e && e.response ? e.response.data.errors : e);
                throw e;
            }
        },
        (events, opts) => {
            if (events.length) {
                const newData = events.slice(0, opts.limit || undefined);
                const hasMore = events.length > (opts.limit || DEFAULT_LIMIT);
                opts.offset = (opts.offset || 0) + (opts.limit || DEFAULT_LIMIT);
                return { opts, hasMore, newData };
            }
            return { opts, hasMore: false, newData: [] };
        },
        opts => `getEvents-${stringify(opts)}`,
        cache,
    );

export const getOccurrence = (query: Webapi.GetOccurrenceQueryVariables) =>
    sdk!.GetOccurrence.queryAsPromise(query).then(r => r.data?.calendar?.occurrence);
